import React from 'react';
import { format } from 'date-fns';

import { IconButton } from '@components/button/Button';
import Tooltip from '@components/tooltip/Tooltip';

import VoiceNotePlayer from './VoiceNotePlayer';

import useCanEditLead from '../../hooks/useCanEditLead';
import { LeadVoiceNote } from '../../types/leadVoiceNote';

interface VoiceNoteItemProps {
  voiceNote: LeadVoiceNote;
  onDeleteClick: (voiceNoteId: string) => void;
  loadSrc: (documentId: string) => Promise<string | undefined>;
}

const VoiceNoteItem: React.FC<VoiceNoteItemProps> = ({
  voiceNote,
  onDeleteClick,
  loadSrc
}) => {
  const canEditLead = useCanEditLead();
  const { document } = voiceNote;
  const tooltipId = `delete-voice-note-${voiceNote.id}`;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-gray-900">
            {voiceNote.owner?.name}
          </span>
          <span className="text-sm text-gray-500">
            {format(new Date(voiceNote.created_at), 'dd/MM/yy, hh:mm a')}
          </span>
        </div>
        <IconButton
          iconName="trash"
          variant="transparent"
          size="none"
          className="!p-1 text-error40 disabled:opacity-50"
          iconSize="medium"
          handleClick={() => onDeleteClick(voiceNote.id)}
          data-tooltip-id={tooltipId}
          disabled={!canEditLead}
          aria-label="Delete voice note"
        />
        <Tooltip id={tooltipId} type="text" tooltipText="Delete" />
      </div>
      {document ? (
        <VoiceNotePlayer
          title={document.file_name}
          loadSrc={() => loadSrc(document.id)}
        />
      ) : (
        <p className="rounded-lg border border-grey30 px-4 py-3 text-sm text-gray-500">
          Voice note unavailable
        </p>
      )}
    </div>
  );
};

export default VoiceNoteItem;
